import { cn } from '@/utils';
import { useLeftHandSideMenu } from './LeftHandSidebarMenuProvider';

export default function LeftHandSideMenuTrigger(props: { className?: string; iconClass?: string; iconSize?: number }) {
  const { isSidebarMenuOpen, toggleSidebarMenu } = useLeftHandSideMenu();
  const iconSize = props.iconSize || 45;
  return (
    <button
      className={cn('border-none items-center justify-center p-0 rounded-r pointer', props.className)}
      onClick={(e) => {
        e.stopPropagation();
        return toggleSidebarMenu();
      }}
    >
      <span className="sr-only">{`${!isSidebarMenuOpen ? 'Open' : 'Close'} menu`}</span>
      <div className={'flex items-center justify-center rounded-circle p-1'}>
        <div
          className={cn('flex items-center justify-center', {
            'rotate-180': !isSidebarMenuOpen,
          })}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={iconSize}
            height={iconSize}
            viewBox="0 0 45 45"
            fill="none"
            className={cn('text-secondary', props.iconClass)}
          >
            <path
              d="M22.5001 2.08334C11.2243 2.08334 2.08341 11.2242 2.08341 22.5C2.08341 33.7758 11.2243 42.9167 22.5001 42.9167C33.7759 42.9167 42.9167 33.7758 42.9167 22.5C42.9168 11.2242 33.7759 2.08334 22.5001 2.08334Z"
              fill="currentColor"
            />
            <path d="M22.5001 14.3333L14.3334 22.5L22.5001 30.6667" fill="currentColor" />
            <path
              d="M22.5001 14.3333L14.3334 22.5M14.3334 22.5L22.5001 30.6667M14.3334 22.5L30.6667 22.5M2.08341 22.5C2.08341 11.2242 11.2243 2.08334 22.5001 2.08334C33.7759 2.08334 42.9168 11.2242 42.9167 22.5C42.9167 33.7758 33.7759 42.9167 22.5001 42.9167C11.2243 42.9167 2.08341 33.7758 2.08341 22.5Z"
              stroke="#006185"
              strokeWidth={4}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </button>
  );
}
